import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';

class TapeDeliveriesRepository extends HttpRepository {
    private static readonly RESOURCE = 'tape-management';

    /**
     * Obtiene el listado de Cambios de Cintas de acuerdo a los parámetros enviados
     * @param customerId id del cliente que inicia sesión
     * @param limit cantidad de Cambios de Cinta a listar
     * @param start número por el cual se empiezan a listar los Cambios de Cinta
     * @param keyword palabra clave por la cual se desean filtrar los cambios de cintas
     */
    getTapeDeliveries({ customerId, limit, start, keyword }) {
        return this.get(
            this.createUri([`${TapeDeliveriesRepository.RESOURCE}`], {
                customerId,
                limit,
                start,
                keyword,
            }),
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Permite obtener un Cambio de Cinta de acuerdo al identificador enviado
     * @param tapeDeliveryId identificador del cambio de cinta solicitado
     */
    getTapeDeliveryById(tapeDeliveryId: number) {
        return this.get(
            this.createUri([`${TapeDeliveriesRepository.RESOURCE}`, tapeDeliveryId]),
            this.createAuthorizationHeader(),
        );
    }
}

export default new TapeDeliveriesRepository();
